import React, { useEffect, useState } from 'react'
import { Delete_Field_Api, GetAll_Paging_Field_Api } from '../../API/FieldApi';
import { ConfigProvider,Button, Col, Modal, Pagination, Row } from 'antd';
import faIR from 'antd/locale/fa_IR';
import { CloseOutlined, DeleteOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, RollbackOutlined } from '@ant-design/icons';
// ======================================================================
export const AllFieldComponent = ({ objectTypeId, objectTypeTitle, setLoading, showMessage, currentPage, setCurrentPage, version, onAddClick, onEdit, onRowDeleted, onBackClick }) => {
    // =================================================================
    const [fields, setFields] = useState([]);
    const [pageCount, setPageCount] = useState(4);
    // =================================================================
    useEffect(() => {
        loadFields();
    }, [objectTypeId, currentPage, version]);
    // =================================================================
    const loadFields = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_Field_Api({ pageNumber: currentPage, objectTypeId: objectTypeId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setFields(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const deleteRow = async (id) => {
        setLoading(true);
        try {
            let data = await Delete_Field_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            <Row className='sectionTitle'>
                <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                    <Button onClick={() => onBackClick()}>
                        <DoubleRightOutlined />
                        بازگشت
                    </Button>
                </Col>
                <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                    <h2 >
                        فیلدهای {objectTypeTitle}
                    </h2>
                </Col>
                <Col xs={8} sm={8} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                    <Button className='btn-primary' onClick={() => onAddClick()} >
                        <PlusOutlined />
                        ایجاد رکورد جدید</Button>

                </Col>
            </Row>

            <div className='container'>
                {fields.map((field) =>
                    <>
                        <Row key={field.id} className="valueRow">
                            <Col xs={12} sm={12} md={12} lg={15} xl={15}>  {field.title} </Col>

                            <Col xs={12} sm={12} md={12} lg={9} xl={9} style={{ textAlign: "left" }}>
                                <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(field.id)}>
                                    <EditOutlined />
                                    ویرایش
                                </Button>
                                <Button
                                    className='btn-danger'
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'آیا از حذف ' + field.title + ' اطمینان دارید؟',
                                            onOk: () => { deleteRow(field.id) },
                                            footer: (_, { OkBtn, CancelBtn }) => (
                                                <>
                                                    <CancelBtn />
                                                    <OkBtn />
                                                </>
                                            ),
                                        });
                                    }}
                                >
                                    <DeleteOutlined />
                                    حذف</Button>
                            </Col>
                        </Row>
                    </>
                )}

            </div>
            <ConfigProvider direction="rtl" locale={faIR}>
                <Pagination current={currentPage}
                    showSizeChanger={false}
                    showQuickJumper={false}
                    align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
            </ConfigProvider>
        </>
    )
}
